import { Button, CircularProgress } from "@material-ui/core";
import { useCallback } from "react";
import { useCoupons } from "../../../graphql/hooks/useCoupons";
import { Coupon } from "../../../graphql/models";

export type GenerateCouponReportProps = {
  coupon: Coupon;
  buttonLabel?: string;
};
export function GenerateCouponReport(props: GenerateCouponReportProps) {
  const { coupon, buttonLabel } = props;

  const { createCouponUsageReportLoading, createCouponUsageReport } =
    useCoupons({
      onCouponUsageReportCreated: (attachment) => {
        window.open(attachment.url);
      },
    });

  const triggerCreateCouponUsageReport = useCallback(() => {
    createCouponUsageReport(coupon.id);
  }, [coupon.id, createCouponUsageReport]);

  return (
    <Button
      disabled={createCouponUsageReportLoading}
      onClick={triggerCreateCouponUsageReport}
      variant="contained"
    >
      {!createCouponUsageReportLoading &&
        (buttonLabel ?? `Report utilizzo coupon ${coupon.code}`)}
      {createCouponUsageReportLoading && <CircularProgress />}
    </Button>
  );
}
